



// // Seleziona gli elementi SVG
// const elements = document.querySelectorAll('.hero-v1 img');

// // Applica un'animazione di parallasse a ciascun elemento
// elements.forEach((element, index) => {
//     const scrubValue = 0.8 + index * 0.5;  // Incrementa il valore di `scrub` per ogni elemento

//     gsap.fromTo(element, 
//       { y: 0 }, // Posizione iniziale (modificabile a seconda dell'effetto desiderato)
//       {
//         y: 100, // Posizione finale
//         scrollTrigger: {
//           trigger: element,
//           start: "top bottom", // Quando l'elemento entra nella viewport
//           end: "bottom top", // Quando l'elemento esce dalla viewport
//           scrub: scrubValue,
//           markers: false, // Mostra i marker di debug (rimuovili in produzione)
//           toggleActions: "restart pause reverse pause"
//         }
//       }
//     );
// });

// gsap.to(".hero-v1 img", {
//     yPercent: -50,
//     ease: "none",
//     scrollTrigger: {
//       trigger: ".pSection",
//       // start: "top bottom", // the default values
//       // end: "bottom top",
//       scrub: true
//     }, 
//   });

  // gsap.to(".hero-v3 img", {
  //   yPercent: 40, // Modifica la percentuale per controllare la velocità del parallasse
  //   ease: "none",
  //   scrollTrigger: {
  //     trigger: ".hero-v1",
  //     start: "top bottom", // Inizio dell'effetto di parallasse
  //     end: "bottom top",   // Fine dell'effetto di parallasse
  //     scrub: true,         // Sincronizza l'animazione con lo scroll
  //     invalidateOnRefresh: true
  //   }
  // });